<template>
  <v-layout fill-height>
    <v-sheet width="100%" height="100%" elevation="0">
      <v-row>
        <v-col cols="6">
          <v-img height="100vh" :src="loginImg"></v-img>
        </v-col>
        <v-col cols="6">
          <v-card
              v-if="messages.verifyEmail.success"
              height="100%"
              elevation="0"
              class="pa-5 mx-auto d-flex flex-column align-center justify-center"
              color="white"
          >
            <v-img :src="logo" max-width="200" max-height="100" contain />
            <label class="logo-subtitle">DEMAND MEETS SUPPLY</label>
            <v-card-title>Deine E-Mail wurde bestätigt</v-card-title>
            <p class="mt-5 login-info">
              Du kannst dich nun mit Deinen Anmeldedaten einloggen. <br />
              Viel Spaß auf Manushare!
            </p>
            <v-btn
              class="ma-4 btn-ver rounded-pill"
              small
              elevation="0"
              rounded
              color="secondary"
              @click="$router.push('/login')"
            >
				Zum Login
            </v-btn>
          </v-card>
          <v-card
              v-if="messages.verifyEmail.error"
              height="100%"
              elevation="0"
              class="pa-5 mx-auto d-flex flex-column align-center justify-center"
              color="#ffffff"
          >
            <v-img :src="logo" max-width="200" max-height="100" contain />
            <label class="logo-subtitle">DEMAND MEETS SUPPLY</label>
            <p class="mt-5 login-info">
              Deine E-Mail konnte nicht verifiziert werden.
            </p>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import loginImg from '../../assets/login.jpg'
import logo from '../../assets/manushare.png'

export default {
	name: 'VerifyEmail',
	data () {
		return {
			id: '',
			emailHash: '',
			loginImg: loginImg,
			logo: logo,
			messages: {
				verifyEmail: {
					success: '',
					error: ''
				}
			}
		}
	},
	computed: {
		...mapState('auth', ['user'])
	},
	created () {
		if (this.user) {
			this.logout().then(console.log('logout-complete'))
		}
	},
	mounted () {
		this.id = this.$route.query.id
		this.hash = this.$route.query.hash
		this.newMail = this.$route.query.newMail
		this.sendVerifyEmailRequest()
	},
	methods: {
		...mapActions('auth', ['verifyEmail', 'logout']),
		sendVerifyEmailRequest () {
			this.verifyEmail({ id: this.id, hash: this.hash, newMail: this.newMail })
				.then(() => {
					this.messages.verifyEmail.success =
            'E-Mail wurde erfolgreich verifiziert.'
				})
				.catch(() => {
					this.messages.verifyEmail.error =
            'E-Mail konnte nicht verifiziert werden.'
				})
		}
	}
}
</script>

<style scoped>
.logo-subtitle {
  color: #19d3da !important;
  font-size: 10px;
  font-weight: bold;
}

.v-card__title {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 33px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #303941;
}
.login-info {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #667085;
}
.theme--light .btn-ver {
  font-family: "Karla";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
}
</style>
